import { render, staticRenderFns } from "./TabelaFrete.vue?vue&type=template&id=d4f6d124"
import script from "./TabelaFrete.vue?vue&type=script&lang=js"
export * from "./TabelaFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports